import { incompatibilityAnalysisActions } from '../actions'

const {
  FETCHING_CABINETS,
  FETCH_CABINETS,
  FETCH_CABINETS_ERROR,
  ADDING_CABINET,
  ADD_CABINET,
  ADD_CABINET_ERROR,
  REMOVING_CABINET,
  REMOVE_CABINET,
  REMOVE_CABINET_ERROR,
  SEARCHING_CABINET,
  SEARCH_CABINET,
  SEARCH_CABINET_ERROR,
  REMOVING_CABINET_PRODUCT,
  REMOVE_CABINET_PRODUCT,
  REMOVE_CABINET_PRODUCT_ERROR,
  ADDING_CABINET_PRODUCT,
  ADD_CABINET_PRODUCT,
  ADD_CABINET_PRODUCT_ERROR,
  CHANGE_SELECT_INPUT,
  CHANGE_LAST_UPDATE,
  UPDATING_CABINET,
  UPDATE_CABINET,
  UPDATE_CABINET_ERROR,
  FETCH_DOWNLOAD_PDF,
  FETCHING_DOWNLOAD_PDF,
  FETCH_DOWNLOAD_PDF_ERROR,
  CHANGE_STATUS_DOWNLOAD_ERROR,
  FETCHING_QRCODE,
  FETCH_QRCODE,
  FETCH_QRCODE_ERROR,
  OPEN_INCOMPATIBILITY_GRID,
  CLOSE_INCOMPATIBILITY_GRID,
  FETCHING_INCOMPATIBILITY_GRID,
  FETCH_INCOMPATIBILITY_GRID,
  FETCH_INCOMPATIBILITY_GRID_ERROR,
  FETCHING_INCOMPATIBILITY_GRID_PDF,
  FETCH_INCOMPATIBILITY_GRID_PDF,
  FETCH_INCOMPATIBILITY_GRID_PDF_ERROR,
  FETCHING_INCOMPATIBILITY_GRID_XLSX,
  FETCH_INCOMPATIBILITY_GRID_XLSX,
  FETCH_INCOMPATIBILITY_GRID_XLSX_ERROR
} = incompatibilityAnalysisActions

// Chave escrita UMA vez e reusada no mapStateToProps do modal. O bug de
// `fetch_errors.cabinet` (singular) x `cabinets` (plural) em IncompatibilityAnalysis.js
// nasceu de duplicar a string nos dois lados.
export const INCOMPATIBILITY_GRID_KEY = 'incompatibility_grid'

const initialState = {
  loading: {
    cabinets: false,
    cabinet: false,
    download: false,
    qr_code: false
  },
  fetch_errors: {
    cabinets: false,
    download: false,
    qr_code: false
  },
  cabinets: [],
  last_update: undefined,
  total_records: undefined,
  modalOpen: false,

  // Sub-arvore isolada de proposito: FETCH_CABINETS_ERROR substituia o objeto
  // fetch_errors inteiro (sem spread), o que apagaria flags planos guardados ali.
  [INCOMPATIBILITY_GRID_KEY]: {
    open: false,
    scope: null,
    data: null,
    loading: false,
    error: false,
    downloading: false,
    downloadingXlsx: false,
    // false | 'busy' (servidor já exportando outra matriz) | 'failed'. Compartilhado
    // por PDF e Excel: só uma nova tentativa limpa o aviso - o sucesso da OUTRA
    // exportação, que pode chegar depois, não pode apagá-lo.
    downloadError: false
  }
}

const incompatibilityAnalysis = (state = initialState, action = '') => {
  switch (action.type) {
    case ADDING_CABINET:
      return {
        ...state,
        loading: {
          ...state.loading,
          cabinet: true
        },
        fetch_errors: {
          ...state.fetch_errors,
          cabinets: false
        }
      }

    case ADD_CABINET:
      return {
        ...state,
        cabinets: [...state.cabinets, action.cabinet],
        loading: {
          ...state.loading,
          cabinet: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          cabinets: false
        }
      }

    case ADD_CABINET_ERROR:
      return {
        ...state,
        loading: {
          ...state.loading,
          cabinet: false
        }
      }

    case UPDATING_CABINET:
      return {
        ...state,
        loading: {
          ...state.loading,
          cabinet: true
        },
        fetch_errors: {
          ...state.fetch_errors,
          cabinets: false
        }
      }

    case UPDATE_CABINET:
      return {
        ...state,
        cabinets: state.cabinets.map(
          cabinet => (cabinet.id === action.cabinet.id ? action.cabinet : cabinet)
        ),
        loading: {
          ...state.loading,
          cabinet: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          cabinets: false
        }
      }

    case UPDATE_CABINET_ERROR:
      return {
        ...state,
        loading: {
          ...state.loading,
          cabinet: false
        }
      }

    case REMOVING_CABINET:
      return {
        ...state,
        fetch_errors: {
          ...state.fetch_errors,
          cabinets: false
        },
        cabinets: state.cabinets.map(cabinet => {
          if (cabinet.id === action.cabinetId) {
            cabinet.loading = true
          }

          return cabinet
        })
      }

    case REMOVE_CABINET:
      return {
        ...state,
        cabinets: state.cabinets.filter(item => {
          return item.id !== action.cabinetId
        }),
        fetch_errors: {
          ...state.fetch_errors,
          cabinets: false
        }
      }

    case REMOVE_CABINET_ERROR:
      return {
        ...state,
        fetch_errors: {
          ...state.fetch_errors,
          cabinets: true
        },
        cabinets: state.cabinets.map(cabinet => {
          if (cabinet.id === action.cabinetId) {
            cabinet.loading = false
          }

          return cabinet
        })
      }

    case FETCHING_CABINETS:
      return {
        ...state,
        loading: {
          ...state.loading,
          cabinets: true
        },
        fetch_errors: {
          ...state.fetch_errors,
          cabinets: false
        }
      }

    case FETCH_CABINETS:
      return {
        ...state,
        cabinets: action.cabinets,
        last_update: action.last_update,
        loading: {
          ...state.loading,
          cabinets: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          cabinets: false
        }
      }

    case FETCH_CABINETS_ERROR:
      return {
        ...state,
        loading: {
          ...state.loading,
          cabinets: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          cabinets: true
        }
      }

    case SEARCHING_CABINET:
      return {
        ...state,
        fetch_errors: {
          ...state.fetch_errors,
          search: false
        }
      }

    case SEARCH_CABINET:
      return {
        ...state,
        fetch_errors: {
          ...state.fetch_errors,
          search: false
        }
      }

    case SEARCH_CABINET_ERROR:
      return {
        ...state,
        fetch_errors: {
          ...state.fetch_errors,
          search: true
        }
      }

    case ADDING_CABINET_PRODUCT:
      return {
        ...state,
        cabinets: state.cabinets.map(cabinet => {
          if (cabinet.id === action.cabinetId) {
            cabinet.loading = true
          }

          return cabinet
        })
      }

    case ADD_CABINET_PRODUCT:
      return {
        ...state,
        cabinets: state.cabinets.map(cabinet => {
          if (cabinet.id === action.cabinetId) {
            cabinet.cabinet_products.push(action.product)
            cabinet.inputValue = ''
            cabinet.loading = false
          }

          return cabinet
        })
      }

    case ADD_CABINET_PRODUCT_ERROR:
      return {
        ...state
      }

    case REMOVING_CABINET_PRODUCT:
      return {
        ...state,
        cabinets: state.cabinets.map(cabinet => {
          if (cabinet.id === action.cabinetId) {
            cabinet.loading = true
          }

          return cabinet
        })
      }

    case REMOVE_CABINET_PRODUCT:
      return {
        ...state,
        cabinets: state.cabinets.map(cabinet => {
          if (cabinet.id === action.cabinetId) {
            const products = cabinet.cabinet_products.filter(product => {
              return product.id !== action.productId
            })

            cabinet.cabinet_products = products
            cabinet.loading = false
          }

          return cabinet
        })
      }

    case REMOVE_CABINET_PRODUCT_ERROR:
      return {
        ...state,
        cabinets: state.cabinets.map(cabinet => {
          if (cabinet.id === action.cabinetId) {
            cabinet.loading = false
          }

          return cabinet
        })
      }

    case CHANGE_SELECT_INPUT:
      return {
        ...state,
        cabinets: state.cabinets.map(cabinet => {
          if (cabinet.id === action.cabinetId) {
            cabinet.inputValue = action.value
            cabinet.loading = false
          }

          return cabinet
        })
      }

    case CHANGE_LAST_UPDATE:
      return {
        ...state,
        last_update: new Date().toISOString()
      }

    case FETCHING_DOWNLOAD_PDF:
      return {
        ...state,
        loading: {
          ...state.loading,
          download: true
        }
      }

    case FETCH_DOWNLOAD_PDF:
      return {
        ...state,
        loading: {
          ...state.loading,
          download: false
        }
      }

    case FETCH_DOWNLOAD_PDF_ERROR:
      return {
        ...state,
        loading: {
          ...state.loading,
          download: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          download: true
        }
      }

    case CHANGE_STATUS_DOWNLOAD_ERROR:
      return {
        ...state,
        fetch_errors: {
          ...state.fetch_errors,
          download: false
        }
      }

    case FETCHING_QRCODE:
      return {
        ...state,
        loading: {
          ...state.loading,
          qr_code: true
        },
        fetch_errors: {
          ...state.fetch_errors,
          qr_code: false
        }
      }

    case FETCH_QRCODE:
      return {
        ...state,
        loading: {
          ...state.loading,
          qr_code: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          qr_code: false
        }
      }

    case FETCH_QRCODE_ERROR:
      return {
        ...state,
        loading: {
          ...state.loading,
          qr_code: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          qr_code: true
        }
      }

    case OPEN_INCOMPATIBILITY_GRID:
      return {
        ...state,
        [INCOMPATIBILITY_GRID_KEY]: {
          ...state[INCOMPATIBILITY_GRID_KEY],
          open: true,
          scope: action.scope,
          data: null,
          // `loading` já sobe aqui: o FETCHING_ só chega no componentDidUpdate do modal,
          // um render depois, e nesse intervalo o modal renderizaria o corpo vazio.
          loading: true,
          error: false
        }
      }

    case CLOSE_INCOMPATIBILITY_GRID:
      return {
        ...state,
        [INCOMPATIBILITY_GRID_KEY]: {
          ...initialState[INCOMPATIBILITY_GRID_KEY]
        }
      }

    case FETCHING_INCOMPATIBILITY_GRID:
      return {
        ...state,
        [INCOMPATIBILITY_GRID_KEY]: {
          ...state[INCOMPATIBILITY_GRID_KEY],
          loading: true,
          error: false
        }
      }

    case FETCH_INCOMPATIBILITY_GRID:
      return {
        ...state,
        [INCOMPATIBILITY_GRID_KEY]: {
          ...state[INCOMPATIBILITY_GRID_KEY],
          loading: false,
          error: false,
          data: action.data
        }
      }

    case FETCH_INCOMPATIBILITY_GRID_ERROR:
      return {
        ...state,
        [INCOMPATIBILITY_GRID_KEY]: {
          ...state[INCOMPATIBILITY_GRID_KEY],
          loading: false,
          error: true,
          data: null
        }
      }

    case FETCHING_INCOMPATIBILITY_GRID_PDF:
      return {
        ...state,
        [INCOMPATIBILITY_GRID_KEY]: {
          ...state[INCOMPATIBILITY_GRID_KEY],
          downloading: true,
          downloadError: false
        }
      }

    case FETCH_INCOMPATIBILITY_GRID_PDF:
      return {
        ...state,
        [INCOMPATIBILITY_GRID_KEY]: {
          ...state[INCOMPATIBILITY_GRID_KEY],
          downloading: false
        }
      }

    case FETCH_INCOMPATIBILITY_GRID_PDF_ERROR:
      return {
        ...state,
        [INCOMPATIBILITY_GRID_KEY]: {
          ...state[INCOMPATIBILITY_GRID_KEY],
          downloading: false,
          downloadError: action.busy ? 'busy' : 'failed'
        }
      }

    // Flag própria: os dois botões convivem no modal e cada um tem o seu loader.
    case FETCHING_INCOMPATIBILITY_GRID_XLSX:
      return {
        ...state,
        [INCOMPATIBILITY_GRID_KEY]: {
          ...state[INCOMPATIBILITY_GRID_KEY],
          downloadingXlsx: true,
          downloadError: false
        }
      }

    case FETCH_INCOMPATIBILITY_GRID_XLSX:
      return {
        ...state,
        [INCOMPATIBILITY_GRID_KEY]: {
          ...state[INCOMPATIBILITY_GRID_KEY],
          downloadingXlsx: false
        }
      }

    case FETCH_INCOMPATIBILITY_GRID_XLSX_ERROR:
      return {
        ...state,
        [INCOMPATIBILITY_GRID_KEY]: {
          ...state[INCOMPATIBILITY_GRID_KEY],
          downloadingXlsx: false,
          downloadError: action.busy ? 'busy' : 'failed'
        }
      }

    default:
      return state
  }
}

export default incompatibilityAnalysis



// WEBPACK FOOTER //
// ./src/reducers/incompatibilityAnalysis.js